export const AUTO_LABEL_NAME = 'Vehicle Info';
export const DRIVER_LABEL_NAME = 'Driver Info';
export const POLICY_LABEL_NAME = 'Policy Info';
